export default __webpack_public_path__ + "static/media/default_image.8bbddd4f.png";